import icon from 'vue-svgicon';

icon.register({
    'regular/phone-actions-next': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12.37 22.54l.01.007a4.5 4.5 0 0 0 5.6-.615l.629-.629a1.5 1.5 0 0 0 0-2.122l-2.653-2.651a1.5 1.5 0 0 0-2.122 0h0a1.5 1.5 0 0 1-2.121 0l-4.242-4.243a1.5 1.5 0 0 1 0-2.121h0a1.5 1.5 0 0 0 0-2.122L4.819 5.393a1.5 1.5 0 0 0-2.121 0l-.63.629a4.5 4.5 0 0 0-.614 5.6l.006.01A40.606 40.606 0 0 0 12.37 22.54zM14.25 9h0a5.25 5.25 0 0 1 5.25-5.25h3.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.25.75l3 3-3 3"/>`,
    },
});
